import * as React from 'react'
import { SVGProps } from 'react'
export const RuwardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={51}
    height={51}
    fill="none"
    {...props}
  >
    <rect
      width={49.5}
      height={49.5}
      x={0.75}
      y={0.75}
      fill="#F3F3F3"
      stroke="#F3F3F3"
      strokeWidth={1.5}
      rx={24.75}
    />
    <path
      fill="#AEC524"
      fillRule="evenodd"
      d="M25.5 1.5c13.255 0 24 10.747 24 24 0 13.264-10.746 24.002-24 24.002-13.253 0-24-10.739-24-24.002 0-13.253 10.747-24 24-24Zm.544 23.098c.289.01.578.043.855.086a677.361 677.361 0 0 1 2.107-5.017c.043-.075.14-.085.172-.053-.032.01-.054.043-.075.085-.065.139-4.155 12.498-4.284 12.926-.298.993.856 1.149.871 1.15 0 0 1.23-4.845 2.247-8.835a7.19 7.19 0 0 1 2.6 1.508l5.187-5.187a14.43 14.43 0 0 0-9.68-4.011v7.348Zm-10.783-2.887a14.462 14.462 0 0 0-4.011 10.01h7.338a7.103 7.103 0 0 1 1.872-4.813l-5.2-5.197Zm15.725 5.197a7.135 7.135 0 0 1 1.871 4.814h7.337a14.459 14.459 0 0 0-4.01-10.012l-5.198 5.198ZM25.4 17.25a14.43 14.43 0 0 0-9.68 4.01l5.198 5.2a7.108 7.108 0 0 1 4.492-1.86v-7.35h-.01Z"
      clipRule="evenodd"
    />
  </svg>
)
